module.exports = __webpack_public_path__ + "static/media/m8tj658.9f0705e3.png";